import * as enhancedconversions from './enhanced-conversions';
import * as meta from './meta';
import * as pinterest from './pinterest';
import * as reddit from './reddit';

declare interface leadTrackingWindow extends Window {
    dataLayer?: Record<string, unknown>[];
}
declare const window: leadTrackingWindow;

// TrackLead reports a quote request (lead) to every social platform we run,
// plus GTM's dataLayer. eventId must be the quote request id hex-encoded so it
// matches the server-side Conversions API id. Meta gets a custom, non-
// optimizing UnqualifiedLead here (#6790) — the standard, optimizing Lead only
// fires server-side once the lead qualifies (#6300).
export function TrackLead(opts: {
    eventId: string;
    value?: number;
    quoteRequestID?: string;
    userID?: string;
    email?: string;
    phone?: string;
    company?: string;
    firstName?: string;
    lastName?: string;
    lineItem?: string;
    type?: string;
    quantity?: number;
    contentCategory?: string;
    contentName?: string;
}): void {
    // The event carries the module's gated view — bare names without a
    // complete address are withheld (Google's all-or-nothing address matching,
    // #9198 class 3). `company` isn't part of Google's user-provided data
    // schema, so it rides alongside untouched.
    const userData = enhancedconversions.Set({
        email: opts.email,
        phone: opts.phone,
        firstName: opts.firstName,
        lastName: opts.lastName,
    });
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'quote-request',
        'quoteRequestId': opts.quoteRequestID,
        'value': opts.value,
        'currency': 'USD',
        'userData': {
            ...userData,
            'company': opts.company,
        },
        'product': {
            'lineItem': opts.lineItem,
            'type': opts.type,
            'quantity': opts.quantity,
        },
        'origin': window.location.href,
    });

    try {
        reddit.TrackLead({
            email: opts.email,
            phoneNumber: opts.phone,
            externalId: opts.userID,
            value: opts.value,
            currency: 'USD',
            contentCategory: opts.contentCategory,
            contentName: opts.contentName,
            contentIds: opts.quoteRequestID ? [opts.quoteRequestID] : undefined,
            contentType: 'product',
            numItems: opts.quantity ?? 1,
            eventId: opts.eventId,
        });
    } catch (e) {
        console.error('reddit lead tracking error', e);
    }

    try {
        pinterest.TrackLead({
            email: opts.email,
            leadType: 'Quote Request',
            eventId: opts.eventId,
        });
    } catch (e) {
        console.error('pinterest lead tracking error', e);
    }

    try {
        meta.TrackUnqualifiedLead({
            value: opts.value,
            currency: 'USD',
            eventId: opts.eventId,
        });
    } catch (e) {
        console.error('meta lead tracking error', e);
    }
}
